import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/pro-light-svg-icons';
import { faStar as faSolidStar } from '@fortawesome/pro-solid-svg-icons';

import './style.scss';

const EMAIL_STATUS_TO_DISPLAY_NAME = {
  unknown: 'Unknown',
  hard_bounce: 'Bounced',
  soft_bounced: 'Bounced',
  marked_spam: 'Spam',
  invalid: 'Invalid',
  contactable: 'Engaged',
};

const SUCCESS_EMAIL_STATUS = ['contactable'];
/**
 * Email A
 * @param {*} emailAddress
 */
function EmailDisplayBlock({ emailAddress }) {
  return (
    <div className="email-address-container">
      <p className="arc-p arc-font-weight-400 arc-color-B65">
        {emailAddress.address}
        <Choose>
          <When condition={emailAddress.is_primary}>
            <FontAwesomeIcon icon={faSolidStar} className="ml8" />
          </When>
          <Otherwise>
            <FontAwesomeIcon icon={faStar} className="ml8" />
          </Otherwise>
        </Choose>
      </p>
      <ul className="email-metadata-list">
        <li className={SUCCESS_EMAIL_STATUS.includes(emailAddress.status) ? 'arc-color-success' : 'arc-color-error'}>
          {EMAIL_STATUS_TO_DISPLAY_NAME[emailAddress.status]}
        </li>
        <If condition={emailAddress.type}>
          <li>
            {emailAddress.type}
          </li>
        </If>
      </ul>
    </div>
  );
}

export default EmailDisplayBlock;
